import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    SafePipe
  ],
  exports: [
    SafePipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipesModule {}
